module.exports = __webpack_public_path__ + "media/serum-pack-large.3a4e60ee.mp4";